import './Dashboard.css';

function Dashboard({ user, onToolSelect, tools, loading }) {

  // Lade-Screen für normale User
  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-content"><h2>Lädt...</h2></div>
      </div>
    );
  }

  // Leere Tools für normale User
  if (tools.length === 0) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-content">
          <h2>Keine Tools verfügbar</h2>
          <p className="subtitle">Ihr Admin muss Ihnen Tools zuweisen.</p>
        </div>
      </div>
    );
  }

  // Normales Dashboard für normale User
  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <h2>Wählen Sie ein Tool</h2>
        <p className="subtitle">Welches Werkzeug möchten Sie nutzen?</p>
        <div className="tools-grid">
          {tools.map((tool) => (
            <div
              key={tool.id}
              className="tool-card"
              onClick={() => onToolSelect(tool.id)}
              style={{ '--tool-color': tool.color }}
            >
              <div className="tool-icon">{tool.icon}</div>
              <h3>{tool.name}</h3>
              <p>{tool.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;